import { createAction } from 'redux-actions';
import { SEND_REGISTRATION, SEND_REGISTRATION_FAILURE, SEND_REGISTRATION_REQUEST, SEND_REGISTRATION_SUCCESS } from './constants';

export const sendRegistration = createAction(SEND_REGISTRATION);
export const sendRegistrationRequest = createAction(SEND_REGISTRATION_REQUEST);
export const sendRegistrationSuccess = createAction(SEND_REGISTRATION_SUCCESS);
export const sendRegistrationFailure = createAction(SEND_REGISTRATION_FAILURE);
